export const ADD = 'entities/picture/ADD';
export const ADD_MULTIPLE = 'entities/picture/ADD_MULTIPLE';
export const UPDATE = 'entities/picture/UPDATE';
export const REMOVE = 'entities/picture/REMOVE';
